import { URI } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const result = await fetch(`${URI}user/relate-available-client`, opts);
  const jsonResult = await result.json();

  if (result.status >= 400) {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult;
};
